import { type SizeObject } from 'views/components/atoms/ResponsiveImage/helpers/types'

export const IMAGE_LAZY_LOAD_START_INDEX = 2
// @ts-ignore
export const IMAGE_SIZES: SizeObject = {
  base: '10em',
  tiny: '42vw',
  medium: '19vw',
}
export const IMAGE_MIN_WIDTH = 138
export const IMAGE_MAX_WIDTH = 272
export const IMAGE_MAX_HEIGHT = 272
